const Experience = ({ from, to, title, description, skills }) => {
  return (
    <div className="row mb-5">
      <div className="col-md-4 text-start text-md-end mb-3">
        <span className='border border-2 border-primary rounded p-2 px-3'>
          <span>{from} - {to}</span>
        </span>
      </div>
      <div className="col-md-8">
        <h4>{title}</h4>
        <div className='f-s-08 lh-sm text-muted'>{description}</div>
        <div>
          {skills != null ? skills.map((item, index) => 
            <span key={index} className="badge bg-primary me-2">
              {item}
            </span>
          ) : ''} 
        </div>
      </div>
    </div>
  );
}

export default Experience;